import {inject} from "@angular/core";
import {CanActivateFn, Router} from '@angular/router';
import { AuthService } from "projects/store/src/app/services/api/v1/auth.service";
import { PermissionService} from "projects/store/src/app/services/permission.service";
import { CustomMessageService } from "library";

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const permissionService = inject(PermissionService);
  const customMessageService = inject(CustomMessageService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    if(route.data['requiredPolicy'] !== undefined) {
      if(permissionService.checkPermission(route.data['requiredPolicy'])) {
        return true;
      }else{
        customMessageService.error('Acceso no permitido');
        return router.createUrlTree(['inicio']);
      }
    }else{
      return true;
    }
  }
  return router.createUrlTree(['login']);
};
